import { ListingType, ListingTypesEnum } from 'modules/shared/modules/categories-shared/interfaces/category-listing-config.interface';

export function getListingSection(type: ListingType): string {
    switch (type) {
        case ListingTypesEnum.Grid:
            return 'listing-grid';
        case ListingTypesEnum.List:
            return 'listing-list';
        case ListingTypesEnum.Lifestyle:
            return 'listing-lifestyle';
        default:
            return 'listing-default';
    }
}
